import React from 'react'
import map from 'lodash/map'

import { withStyles } from 'pmt-ui/styles'
import { FormGroup, FormControlLabel } from 'pmt-ui/Form'
import Checkbox from 'pmt-ui/Checkbox'

const styles = theme => ({
  resizer: {
    maxWidth: '100%',
    transition: 'width 0.4s cubic-bezier(0.680, -0.250, 0.265, 1.250)',
  },
})

const RENDER_TYPE = {
  MOBILE: {
    name: 'MOBILE',
    label: 'Mobile',
    resolution: 360,
  },
  TABLET: {
    name: 'TABLET',
    label: 'Tablette',
    resolution: 1024,
  },
  DESKTOP: {
    name: 'DESKTOP',
    label: 'Ordinateur',
    resolution: 1366,
  },
}

class Resizer extends React.Component {
  state = {
    renderType: RENDER_TYPE.DESKTOP,
  }

  handleChange(renderType) {
    this.setState({
      renderType,
    })
  }

  render() {
    const { children, classes } = this.props

    return (
      <div
        className={classes.resizer}
        style={{ width: `${this.state.renderType.resolution}px` }}
      >
        <FormGroup row>
          {map(RENDER_TYPE, renderType => {
            return (
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={renderType.name === this.state.renderType.name}
                    onChange={() => {
                      this.handleChange(renderType)
                    }}
                  />
                }
                label={renderType.label}
              />
            )
          })}
        </FormGroup>
        {children}
      </div>
    )
  }
}

export default withStyles(styles)(Resizer)
